import React, { useState, useEffect } from "react";

import { Instalacao, StatusPista } from "../models/posto";
import numeral from "numeral";

import CircularProgress from "@material-ui/core/CircularProgress";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import NativeSelect from "@material-ui/core/NativeSelect";
import FormHelperText from "@material-ui/core/FormHelperText";
import List from "@material-ui/core/List";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useFetcher } from "../components/api";

const REFRESH_INTERVAL_MS = 5000;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.primary.light,
    },
  }),
);

export const EncerrantesPage = () => {
  const classes = useStyles();
  const [instalacoes, setInstalacoes] = useState<Instalacao[]>([]);
  const [instalacaoSelecionada, setInstalacaoSelecionada] =
    useState<Instalacao>();

  // O Cloud le o srvaba pela tunnel a cada chamada, entao a tela busca sozinha
  // em vez de esperar um push.
  const { response, error, mutate, isValidating } = useFetcher<StatusPista>(
    "statusPistas",
    REFRESH_INTERVAL_MS,
  );

  const status = response?.data?.data ?? {};
  const carregando = response === undefined && error === undefined;

  // on status change
  useEffect(() => {
    const installs = Object.keys(status).map(
      (x) =>
        ({
          installCode: status[x].ic,
          empresa: {
            codigo: status[x].cod,
            nome: status[x].nome,
          },
        }) as Instalacao,
    );
    setInstalacoes(installs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  useEffect(() => {
    if (instalacoes?.length > 0 && instalacaoSelecionada === undefined)
      setInstalacaoSelecionada(instalacoes[0]);
  }, [instalacoes, instalacaoSelecionada]);

  const handleEmpresaSelectChange = (event: any) => {
    const newValue = instalacoes.find(
      (x) => x.installCode === event.target.value,
    );
    setInstalacaoSelecionada(newValue);
  };

  const statusAutomacao =
    status && instalacaoSelecionada
      ? status[instalacaoSelecionada.installCode]
      : undefined;
  const statusBicos = statusAutomacao?.status ?? [];

  const gridData = statusBicos.map((x) => ({
    bico: x.id,
    encerrante: x.encerrante,
    combustivel: x.combustivelNome,
  }));

  let nav = navigator as any;

  const compartilhar = () => {
    if (nav.share) {
      const text =
        "ENCERRANTES AS " +
        new Date().toLocaleString("pt-br") +
        ": " +
        statusBicos.reduce(
          (a, b) =>
            a +
            "\nBICO " +
            numeral(b.id).format("00") +
            " " +
            b.combustivelNome
              .replace(/GASOLINA/g, "G.")
              .replace(/OLEO/g, "")
              .replace(/HIDRATADO/g, "H.") +
            ": " +
            numeral(b.encerrante).format("0.00"),
          "",
        );

      nav
        .share({
          title: "Encerrantes",
          url: "https://apc-mobile-a329e.web.app/",
          text: text,
        })
        .then(() => {
          alert("Compartilhado com sucesso!");
        })
        .catch(alert);
    } else {
      alert("Dispositivo não aceita compartilhamento em PWA!");
    }
  };

  function getListItem(props: any) {
    return (
      <div key={props.bico}>
        <ListItem>
          <ListItemAvatar>
            <Avatar className={classes.avatar}>{props.bico.toString()}</Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <b style={{ fontSize: "1.1rem" }}>
                  {numeral(props.encerrante).format("(,0.00)")} L.
                </b>
                <span>{props.capacidade}</span>
              </Grid>
            }
            secondary={<span>{props.combustivel}</span>}
          />
        </ListItem>
        <Divider />
      </div>
    );
  }

  return (
    <div>
      {carregando ? (
        <div
          style={{
            marginTop: "100px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress color="secondary" />
          <p>Consultando o serviço de automação do posto....</p>
        </div>
      ) : (
        <div>
          <div
            style={{
              fontSize: "10px",
              width: "100%",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <p>
              Concentrador: {statusAutomacao?.automacao} | Atualizado Em:{" "}
              {statusAutomacao?.atualizadoEm}
            </p>
          </div>

          {instalacoes.length > 0 ? (
            <div>
              {instalacoes.length > 1 ? (
                <FormControl style={{ width: "100%" }}>
                  <InputLabel htmlFor="select-instalacoes">Empresas</InputLabel>
                  <NativeSelect
                    fullWidth={true}
                    value={instalacaoSelecionada}
                    onChange={handleEmpresaSelectChange}
                    inputProps={{
                      id: "select-instalacoes",
                    }}
                  >
                    {instalacoes.map((item, idx) => (
                      <option key={idx} value={item.installCode}>
                        {item.installCode}: {item.empresa.codigo} -{" "}
                        {item.empresa.nome}
                      </option>
                    ))}
                  </NativeSelect>
                  <FormHelperText>Escolha a empresa</FormHelperText>
                </FormControl>
              ) : (
                <></>
              )}

              {statusAutomacao?.error ? (
                <div style={{ textAlign: "center", padding: "24px 0" }}>
                  <p>Posto indisponível no momento.</p>
                  <p style={{ fontSize: "12px" }}>{statusAutomacao.error}</p>
                </div>
              ) : (
                <List>{gridData.map((x) => getListItem(x))}</List>
              )}

              {nav.share && !statusAutomacao?.error && (
                <Button
                  variant="contained"
                  fullWidth
                  color="secondary"
                  onClick={compartilhar}
                >
                  Compartilhar
                </Button>
              )}
            </div>
          ) : (
            <div>
              <p>Nenhum posto com automação encontrado para esta conta.</p>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                disabled={isValidating}
                onClick={() => mutate()}
              >
                Tentar novamente
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
